import React from "react";
import CenteredModal from "./CenteredModal";
import { CheckIcon, XIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import RequestsModel from "../../api/models/RequestsModel";
import moment from "moment";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import ApiDateParser from "../../helpers/parsers/apiDateParser";
type RequestAppointmentResignationProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  request?: RequestsModel | null;
  owner: boolean;
  onApprove?: () => void;
  onDeny?: () => void;
};
export default function RequestAppointmentResignation(
  props: RequestAppointmentResignationProps
) {
  const { open, setOpen, request, owner, onApprove, onDeny } = props;
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const days: any = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };
  return (
    <CenteredModal open={open} setOpen={setOpen}>
      <div className="flex flex-col   w-[270px] sm:w-[400px] md:min-w-[700px]  md:max-w-4xl   gap-2 pb-4">
        <div className="flex items-center justify-end w-full">
          <p className="text-sm text-gray-400">
            {" "}
            {moment(request?.createdAt).fromNow(true)}
          </p>
        </div>
        <div className="flex flex-col justify-between w-full gap-3 sm:gap-0 sm:flex-row">
          <div className="relative flex items-center gap-1 space-x-3">
            <div className="flex-shrink-0">
              <UserProfilePictureAvatar
                profilePictureUrl={request?.user?.profile_picture_url}
                className="w-10 h-10"
                alt="avatar"
              />
            </div>
            <div className="flex-1 min-w-0">
              <a className="focus:outline-none">
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-lg font-semibold text-gray-500">
                  {request?.user?.fullNameWithoutMiddle}
                </p>
              </a>
            </div>
          </div>
          {!!owner && (
            <div className="flex flex-row items-center gap-3">
              <button
                type="button"
                onClick={onDeny}
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-white border border-red-600 rounded-md shadow-sm hover:text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
              >
                <XIcon className="w-5 h-5 " aria-hidden="true" />
                {t("refused")}
              </button>
              <button
                type="button"
                onClick={onApprove}
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
              >
                <CheckIcon className="w-5 h-5 " aria-hidden="true" />
                {t("approved")}
              </button>
            </div>
          )}
        </div>
        <div className="flex flex-col w-full gap-2">
          <div className="flex flex-col w-full gap-2 sm:gap-0 sm:flex-row sm:justify-between ">
            <p className="text-xl font-medium leading-8 text-gray-800">
              {t("proposedSchedule")}
            </p>
          </div>
          <div className="flex flex-col w-full gap-4 sm:flex-row sm:items-center ">
            {request?.slots.map((slot) => (
              <div className="flex flex-col gap-1 w-80">
                <h4 className="text-sm text-gray-500 ">
                  {moment()
                    .day(days?.[slot?.day_of_the_week] ?? 0)
                    .format("dddd")}
                </h4>
                <p className="text-base leading-5 text-brandblue-600">
                  {ApiDateParser.parse(slot?.start_time).format("hh:mm A")}
                  {}
                  {"  -  "}
                  {ApiDateParser.parse(slot?.end_time).format("hh:mm A")}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col w-full gap-2">
          <div className="flex flex-col w-full gap-2 sm:gap-0 sm:flex-row sm:justify-between ">
            {!!request?.recitationScheduleSlots?.length && (
              <p className="text-xl font-medium leading-8 text-gray-800">
                {t("oldSchedule")}
              </p>
            )}
          </div>
          <div className="flex flex-col w-full gap-4 sm:flex-row sm:items-center ">
            <div className="flex flex-col w-full gap-4 sm:flex-row sm:items-center ">
              {!!request?.recitationScheduleSlots &&
                request?.recitationScheduleSlots.map((slot) => {
                  return (
                    <div className="flex flex-col gap-1 w-80">
                      <h4 className="text-sm text-gray-500 ">
                        {moment()
                          .day(days?.[slot?.day_of_the_week] ?? 0)
                          .format("dddd")}
                      </h4>
                      <p className="text-base leading-5 text-brandblue-600">
                        {ApiDateParser.parse(slot?.start_time).format(
                          "hh:mm A"
                        )}
                        {"  -  "}
                        {ApiDateParser.parse(slot?.end_time).format("hh:mm A")}
                      </p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </CenteredModal>
  );
}
